// fetch() for ProView API calls: sends the session as `Authorization: Bearer`.
//
// The frontend (Vercel) and the API (Railway) are different sites, so the
// backend's session cookie is a third-party cookie. Safari/iOS (ITP), Firefox
// strict mode and private windows drop it, which logged users out on their
// very next request. The bearer token is stored by the app itself and does
// not depend on the browser's cookie policy. credentials:'include' is kept
// so the cookie still works where it is allowed.

const TOKEN_KEY = 'proview_session_token';

export const getSessionToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const setSessionToken = (token) => {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    // Storage unavailable (private mode quota, blocked) — cookie-only session
  }
};

export const clearSessionToken = () => setSessionToken(null);

export const authHeaders = (extra = {}) => {
  const token = getSessionToken();
  return token ? { Authorization: `Bearer ${token}`, ...extra } : { ...extra };
};

const apiFetch = (url, options = {}) => {
  const headers = new Headers(options.headers || {});
  const token = getSessionToken();
  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(url, { credentials: 'include', ...options, headers });
};

export default apiFetch;
